import React from "react";
import { KIND_KEY, KINDS } from "@/lib/printess/constants";
import CategoryRow from "./category_row";
import ProductRow from "./product_row";

const PaletteRow = React.memo(function PaletteRow(props) {
  const { item, onSave } = props;
  if (item[KIND_KEY] === KINDS.CATEGORY) {
    return <CategoryRow item={item} onSave={onSave} />;
  }
  if (item._collapsed) {
    return null;
  }
  return <ProductRow item={item} onSave={onSave} />;
});

export default PaletteRow;
